var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-box"},[_c('div',{staticClass:"menu-item",attrs:{"data-test":"menu"},on:{"click":_vm.pushToReservationMenu}},[_vm._v(" "+_vm._s(_vm.$t('parts.menu'))+" ")]),_c('div',{staticClass:"menu-item",attrs:{"data-test":"logout"},on:{"click":_vm.logout}},[_vm._v(" "+_vm._s(_vm.$t('parts.logout'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }